export default __webpack_public_path__ + "static/media/Group 13.f18437f5.png";